import * as Constants from "../../utils/constants";

export const SEARCH_DATA = (data: any) => ({
  type: Constants.SEARCH_DATA,
  payload: data,
});

export const loadSearchData = (data: any, isPagination: boolean) => ({
  type: "loadSearchData",
  payload: {
    data,
    isPagination,
  },
});

export const saveAllSearchData = (data: any, isPagination: boolean) => ({
  type: Constants.SAVE_ALL_SEARCH_DATA,
  payload: {
    data,
    isPagination,
  },
});

export const clearLoads = () => ({
  type: Constants.CLEAR_SEARCH_RESULTS,
  payload: [],
});

export const fetchResults = (
  searchParams: any,
  isPagination: boolean,
  isHideLoader = false,
  callback?: any
) => ({
  type: Constants.FETCH_SEARCH_RESULTS,
  payload: {
    searchParams,
    isPagination,
    isHideLoader,
    callback,
  },
});

export const removeSearchResults = (payload: any) => ({
  type: Constants.REMOVE_SEARCH_RESULTS,
  payload,
});

export const setSearchParams = (payload: any) => ({
  type: Constants.SEARCH_DATA,
  payload,
});

export const showBuyLoadError = (payload: any) => ({
  type: Constants.SHOW_BUYLOAD_API_ERROR,
  payload,
});

export const getCountryStateCodes = () => {
  return {
    type: Constants.GET_STATE_COUNTRY_CODES,
  };
};

export const loadStateCountryCodes = (payload: any, isLoading: boolean) => {
  return {
    type: Constants.LOAD_STATE_COUNTRY_CODES,
    payload: {
      response: payload,
      isLoading,
    },
  };
};
export const getStofLoads = (
  payload: any,
  currentPage: number,
  oldLoads: any[],
  callback?: any
) => ({
  type: Constants.GET_STOF_LOADS,
  payload,
  currentPage,
  oldLoads,
  callback,
});

export const setStofData = (data: any) => ({
  type: Constants.STOF_DATA,
  payload: data,
});
export const updateDateOffset = (data: any) => ({
  type: Constants.UPDATE_DATE_OFFSET,
  payload: data,
});
